import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { sfqApi } from "../../api/feasibility";

export const pmLabel = (emp) => `${emp.name} (${emp.employeeNo})`;

// Employees a study may name, resolved server-side by permission (the profile match is
// only visible to the API). Each hook wraps one candidate endpoint with the same shape.
//
// 본인은 어느 역할 후보에도 넣지 않는다. Reviewer는 Owner의 작업을 승인하는 자리라 자기
// 자신을 지명하면 API가 거절하고(Reviewer는 Owner와 같을 수 없다), Owner 이양과 CRA 배정도
// 지금 화면에서 지명하는 사람 자신을 고르는 선택지는 의미가 없다 — Owner는 이미 그 스터디의
// 모든 작업을 할 수 있다.
function useServerCandidates(fetcher, errorLabel) {
  const me = useSelector((s) => s.userInfo.employeeNo);
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [error, setError]           = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetcher()
      .then((res) => !cancelled && setCandidates(res.data?.data || []))
      .catch(() => !cancelled && setError(errorLabel))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
    // fetcher/errorLabel are module-stable; intentionally run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectable = useMemo(
    () => candidates.filter((emp) => String(emp.employeeNo) !== String(me)),
    [candidates, me]
  );

  return { candidates: selectable, loading, error };
}

// Reviewer candidates — hold SFQ_REVIEWER. Chosen at create and reassignable in detail.
export function useReviewerCandidates() {
  return useServerCandidates(sfqApi.reviewerCandidates, "Reviewer 목록을 불러오지 못했습니다.");
}

// CRA candidates — hold SFQ_CRA_EDIT. Multi-selected at create and edited in detail.
export function useCRACandidates() {
  return useServerCandidates(sfqApi.craCandidates, "CRA 목록을 불러오지 못했습니다.");
}

// Owner candidates — hold SFQ_STUDY_EDIT. Only Admin reassigns a study's owner.
export function useOwnerCandidates() {
  return useServerCandidates(sfqApi.ownerCandidates, "Owner 목록을 불러오지 못했습니다.");
}
